import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidReadingMatrixTimer } from '../../../../mechanics/rid-reading-matrix-timer/rid-reading-matrix-timer';
import { injectQueryParams } from '../../../../utils/route.utils';

@Component({
  selector: 'reading-matrix-timer-page',
  imports: [RidReadingMatrixTimer],
  templateUrl: './reading-matrix-timer-page.html',
})
export class ReadingMatrixTimerPage {
  protected readonly $router = inject(Router);

  protected readonly queryParams = injectQueryParams();
  protected readonly duration = computed(() => parseInt(this.queryParams()['duration'] ?? '30'));
  protected readonly previousWordCount = computed(() => parseInt(this.queryParams()['previous-word-count'] ?? '10'));
}
